import { Text, ActionIcon, Group, Tooltip } from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";
import { useParams } from "react-router-dom";
import { DEZ, DOIS } from "@/utils/constants";
import useRefreshStore from "@/utils/useRefreshStore";
import useMediaGrupoByEmpresaId from "./useGetMediaGrupoByEmpresaId";

const NotaMedia = ({ empresaProjetoId }: { empresaProjetoId: string }) => {
  const { id } = useParams<{ id: string }>();
  const { data, refetch } = useMediaGrupoByEmpresaId({ id: id || "", empresaProjetoId: empresaProjetoId });
  const triggerRefresh = useRefreshStore((state) => state.triggerRefresh);
  let media = 0;
  const hasMediaAvaliador = data?.some((item) => item && item.mediaAvaliador !== undefined);

  if (data)
    for (const item of data) {
      const mediaValue = hasMediaAvaliador ? item?.mediaAvaliador : item?.media;
      media += mediaValue / DEZ || 0;
    }
  media = media / (data?.length || 1);
  const handleRefresh = () => {
    void refetch();
    triggerRefresh();
  };

  return (
    <Group gap="xs" align="center">
      <Text>{media.toFixed(DOIS)}</Text>
      <Tooltip label="Atualizar média">
        <ActionIcon variant="subtle" color="gray" size="sm" onClick={handleRefresh}>
          <IconRefresh size={14} />
        </ActionIcon>
      </Tooltip>
    </Group>
  );
};

export default NotaMedia;
